/** Número de empenho: AAAA + NE + sequência (ex.: 2025NE02173). Vazio é permitido. */
export default function ()
{
	return {
		// Campo usa máscara padrão "$1"; precisa de grupo de captura para não renderizar literal "$1".
		regex: /^$|^(\d{4}NE\d+)$/i,
		filter: /\s+/g,
	};
}
